import { styled } from '../../Styles/stitches.config'

export const StyledFeedbackButtons = styled('div', {
    display: 'grid',
    gap: '$2',
    w: '100%',
    alignText: 'center',
    justifyItems: 'center',
})
export const StyledInputGroup = styled('div', {
    w: '100%',
    justifyItems: 'strech',
})

export const StyledButtons = styled(StyledFeedbackButtons, {
    gridTemplateColumns: 'auto auto',
    justifyItems: 'stretch',
})
